/*
 * @Description:
 * @Author: doris_xu
 * @Date: 2023-03-31 16:45:24
 * @LastEditTime: 2025-10-16 16:38:25
 */
/* eslint-disable */
/* tslint:disable */

import { useState } from 'react'

import JuryCardA from './jury-card/jury-card'
import JuryCardB from './jury-card/jury-card-b'

const Jury = () => {
  const [flag, setFlag] = useState('A')
  return (
    <div className="home" style={{}}>
      {/*<Banner />*/}
      <div
        className="jury__line outlineTitle"
        style={{ textAlign: 'center', marginBottom: '60px' }}>
        <label
          className={`enter_label  ${flag === 'A' ? 'active' : ''}`}
          onClick={() => setFlag('A')}>
          机构专家
        </label>
        {/* <div className={`split__line`}></div> */}
        {/* <label
          className={`enter_label  ${flag === 'B' ? 'active' : ''}`}
          onClick={() => setFlag('B')}
        >
          专业机构专家
        </label> */}
        <p className="expert_tips">排名不分先后</p>
      </div>
      <JuryCardA />
      {/* {flag === 'A' && <JuryCardA />}
      {flag === 'B' && <JuryCardB />} */}
    </div>
  )
}

export default Jury
